import React, { forwardRef } from "react";
import { bool, func, object, oneOf, string } from "prop-types";

import Field from "../Field";
import TextArea from "./components/TextArea";

const TextField = forwardRef(
  (
    {
      className,
      defaultValue,
      disabled,
      error,
      helper,
      id,
      isValid,
      label,
      onChange,
      required,
      textAreaOptions,
      type,
      value,
      ...passThroughProps
    },
    ref
  ) => (
    <Field
      ref={ref}
      className={className}
      error={error}
      helper={helper}
      id={id}
      isValid={isValid}
      label={label}
      {...passThroughProps}
    >
      <TextArea
        defaultValue={defaultValue}
        disabled={disabled}
        isValid={isValid}
        onChange={onChange}
        required={required}
        type={type}
        value={value}
        {...textAreaOptions}
      />
    </Field>
  )
);

TextField.displayName = "TextField";

TextField.propTypes = {
  className: string,
  // eslint-disable-next-line react/require-default-props
  defaultValue: string,
  disabled: bool,
  error: string,
  helper: string,
  hint: string.isRequired,
  id: string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  textAreaOptions: object,
  isValid: bool,
  label: string.isRequired,
  onChange: func,
  required: bool,
  type: oneOf(["email", "number", "text"]),
  // eslint-disable-next-line react/require-default-props
  value: string
};

TextField.defaultProps = {
  className: "",
  disabled: false,
  error: "",
  isValid: true,
  helper: "",
  textAreaOptions: {},
  onChange: () => {},
  required: false,
  type: "text"
};

export default TextField;
